import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import Typography from "@mui/material/Typography";
import React from "react";
function getSteps() {
    return ["Select campaign settings", "Create an ad group", "Create an ad"];
}
function getStepContent(step) {
    switch (step) {
        case 0:
            return "Select campaign settings...";
        case 1:
            return "What is an ad group anyways?";
        case 2:
            return "This is the bit I really care about!";
        default:
            return "Unknown step";
    }
}
export default function StepperExample() {
    const [activeStep, setActiveStep] = React.useState(0);
    const [skipped, setSkipped] = React.useState(new Set());
    const steps = getSteps();
    const isStepOptional = (step) => {
        return step === 1;
    };
    const isStepSkipped = (step) => {
        return skipped.has(step);
    };
    const handleNext = () => {
        const newSkipped = isStepSkipped(activeStep) ? new Set([...skipped].filter((s) => s !== activeStep)) : skipped;
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped(newSkipped);
    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };
    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.");
        }
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setSkipped((prevSkipped) => {
            const newSkipped = new Set(prevSkipped.values());
            newSkipped.add(activeStep);
            return newSkipped;
        });
    };
    const handleReset = () => {
        setActiveStep(0);
    };
    return (_jsxs(Box, Object.assign({ sx: { width: 1 } }, { children: [_jsx(Stepper, Object.assign({ activeStep: activeStep }, { children: steps.map((label, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    if (isStepOptional(index)) {
                        labelProps.optional = _jsx(Typography, Object.assign({ variant: "caption" }, { children: "Optional" }));
                    }
                    if (isStepSkipped(index)) {
                        stepProps.completed = false;
                    }
                    return (_jsx(Step, Object.assign({}, stepProps, { children: _jsx(StepLabel, Object.assign({}, labelProps, { children: label })) }), label));
                }) })), _jsx("div", { children: activeStep === steps.length ? (_jsxs("div", { children: [_jsx(Typography, Object.assign({ sx: { my: 1 } }, { children: "All steps completed - you're finished" })), _jsx(Button, Object.assign({ onClick: handleReset, sx: { mr: 1 } }, { children: "Reset" }))] })) : (_jsxs("div", { children: [_jsx(Typography, Object.assign({ sx: { my: 1 } }, { children: getStepContent(activeStep) })), _jsxs("div", { children: [_jsx(Button, Object.assign({ disabled: activeStep === 0, onClick: handleBack, sx: { mr: 1 } }, { children: "Back" })), isStepOptional(activeStep) && (_jsx(Button, Object.assign({ variant: "contained", color: "primary", onClick: handleSkip, sx: { mr: 1 } }, { children: "Skip" }))), _jsx(Button, Object.assign({ variant: "contained", color: "primary", onClick: handleNext, sx: { mr: 1 } }, { children: activeStep === steps.length - 1 ? "Finish" : "Next" }))] })] })) })] })));
}
